/**
 * Contexto que acompaña a cada error reportado. Todo lo que ayude a correlacionar
 * el fallo del cliente con los logs del backend (mismo tenant, misma ruta, mismo
 * usuario) sin filtrar PII sensible.
 */
export interface ErrorContext {
  /** Ruta SPA donde se disparó el error (`location.pathname`, sin query → sin PII). */
  readonly route: string;
  /** Id del usuario autenticado, o `null` si la sesión aún no se hidrató. */
  readonly userId: string | null;
  /** Tenant activo, o `null` fuera de contexto multi-tenant. */
  readonly tenantId: string | null;
}

/**
 * Port de reporte de errores a un sink externo (Sentry, GlassBox, etc.).
 *
 * Es una abstracción a propósito: el `GlobalErrorHandler` depende de este contrato,
 * no de un SDK concreto. El adapter por defecto (`LoggingErrorReporter`) es un stub
 * que sólo se activa si hay DSN configurado en runtime; adoptar `@sentry/angular` es
 * proveer otro adapter SIN tocar el handler (hexagonal: la app posee el puerto).
 */
export abstract class ErrorReporter {
  abstract report(error: unknown, context: ErrorContext): void;
}
